module.exports = __webpack_public_path__ + "static/img/home_hero.a67d6cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/home_hero.jpg
// module id = 1712
// module chunks = 5